import { render, staticRenderFns } from "./valeSalidasIndex.vue?vue&type=template&id=4445c2b3&scoped=true&"
import script from "./valeSalidasIndex.vue?vue&type=script&lang=ts&"
export * from "./valeSalidasIndex.vue?vue&type=script&lang=ts&"
import style0 from "./valeSalidasIndex.vue?vue&type=style&index=0&id=4445c2b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4445c2b3",
  null
  
)

export default component.exports